import { request } from "../../../Services/Api"

export const getRequestsGifts = (params) => request.api.get(`/payments/requests/gift/`, params)
